module.exports = __webpack_public_path__ + "images/bg-user-case_b0e7d35fcbe9e726313401b79db1549c.png";